import React, { useContext } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

import MainLayout from '../layouts/MainLayout'
import UserInfos from '../components/UserInfos'
import TrainingScenarioSection from "../components/TrainingScenarioSection";
import { TrainingContext } from "../services/Training";
import { VIEWS_MODE } from "../constants";

const TrainingModuleScenario = () => {
  const { id, moduleId } = useParams();
  const { state } = useLocation();
  const [ trainingContext ] = useContext(TrainingContext)
  const { name, goal } = state as any
  if(!trainingContext) {
    return <Navigate to='/training' />
  }

  if(!name) {
    return <Navigate to={`/training/${id}?tab=${Object.keys(VIEWS_MODE)[1]}`} />
  }

  return (
    <MainLayout>
      <div className="h-full flex flex-col">
        <div className="flex">
          <div className="flex-1">
            <h1 className="text-4xl font-semibold text-gray-800 truncate overflow-hidden">Scénarisation du module {name}</h1>
            <h2 className=" text-gray-400">
              Formation : {trainingContext.name}
              &nbsp;|&nbsp;
              Objectif(s) : {goal}
            </h2>
          </div>
          <UserInfos/>
        </div>
        <TrainingScenarioSection trainingId={id} moduleId={moduleId}/>
      </div>
    </MainLayout>
  ) 
}

export default TrainingModuleScenario